$shm_hitalama_map_widget_float_code_bench $mol_view
	widget $shm_hitalama_map_widget
	map $shm_hitalama_map
	Map_page $shm_hitalama_map_page
	context *
	is_atom false
	auto /
		<= run_if_enabled null
	run null
	sub /
		<= Card $mol_list
			sub /
				<= Run_row $mol_view
					sub /
						^ run_button / <= Run $mol_button_major
							sub /
								<= Run_icon $mol_icon_play
								\Выполнить
							click? <=> run_click? null
						<= Create_view_widget $mol_button_minor
							sub /
								<= Next_icon $mol_icon_eye
								\Виджет с результатом
								<= Next_right_icon $mol_icon_chevron_double_right
							click? <=> create_view_widget? null
				<= Time $mol_paragraph
					title <= time_passed \{start}   Затрачено: {passed}
				^ running_fiber_visible /
				^ result_visible /
					<= Result_view $shm_hitalama_map_widget_float_code_bench_result
						state <= process_state
	Process $shm_hitalama_process_view
		host <= process_host null
		method_name \run_auto
		state => process_state
		started_at => started_at
		duration => duration
